import { useState } from 'react';
import { ArrowRight, MapPin, Menu, Phone, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: 'Acasă' },
  { to: '/packages', label: 'Cursuri și prețuri' },
  { to: '/teachers', label: 'Profesori' },
  { to: '/contact', label: 'Contact' },
  { to: '/colaborari', label: 'Cum colaborăm' }
];

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navClass = (path: string) => (
    location.pathname === path
      ? 'text-blue-700 bg-blue-50'
      : 'text-ink/70 hover:text-blue-700 hover:bg-blue-50/70'
  );

  return (
    <>
      <a href="#main-content" className="skip-link">Sari la conținut</a>

      <header className="sticky top-0 z-50">
        <div className="hidden bg-ink text-sm text-paper md:block">
          <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-2">
            <p className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-sun" />
              Șoseaua Colentina 16, București
            </p>
            <a href="tel:0726423784" className="flex items-center gap-2 font-semibold transition-colors hover:text-sun">
              <Phone className="h-4 w-4" />
              0726 423 784
            </a>
          </div>
        </div>

        <nav aria-label="Navigație principală" className="border-b border-blue-100 bg-paper shadow-float">
        <div className="mx-auto flex h-[4.75rem] max-w-7xl items-center justify-between px-4 sm:px-6">
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="group flex items-center gap-3" aria-label="Centrul Progres, pagina principală">
            <span className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-2xl bg-white shadow-float transition-transform duration-300 group-hover:-rotate-2 group-hover:scale-105">
              <img src="/logo.jpg" alt="" className="h-full w-full scale-125 object-cover" />
            </span>
            <span>
              <span className="block font-display text-xl font-bold leading-none text-ink">Centrul Progres</span>
              <span className="mt-1 block text-xs font-semibold text-blue-700">Centru de meditații</span>
            </span>
          </Link>

          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${navClass(item.to)}`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <Link
            to="/contact"
            className="hidden items-center gap-2 rounded-full bg-blue-600 px-5 py-3 text-sm font-bold text-white shadow-float transition-all duration-300 hover:-translate-y-0.5 hover:bg-blue-700 lg:flex"
          >
            Cere detalii
            <ArrowRight className="h-4 w-4" />
          </Link>

          <button
            type="button"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-navigation"
            aria-label={isMenuOpen ? 'Închide meniul' : 'Deschide meniul'}
            className="flex h-11 w-11 items-center justify-center rounded-full bg-blue-50 text-blue-700 lg:hidden"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {isMenuOpen && (
          <div id="mobile-navigation" className="border-t border-blue-100 bg-paper px-4 pb-5 pt-3 lg:hidden">
            <div className="mx-auto flex max-w-7xl flex-col gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setIsMenuOpen(false)}
                  className={`rounded-xl px-4 py-3 font-semibold ${navClass(item.to)}`}
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsMenuOpen(false)}
                className="mt-2 flex items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-3 font-bold text-white"
              >
                Cere detalii <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        )}
        </nav>
      </header>
    </>
  );
};

export default Navbar;
